import MetaData from '../components/layouts/MetaData';
import hospitalInfo from '../constants/hospitalInfo';

export default function Redirect() {
    const websiteUrl = hospitalInfo.website || 'https://greennaturopathy.com/';
    const reviewUrl = hospitalInfo.googleReviewUrl || 'https://g.page/r/CfNAbnnuCG74EAI/review';

    return (
        <>
            <MetaData title="Green Naturopathy" />
            <div className="login-page">
                <div className="login-card">
                    {/* Card top - brand logo */}
                    <div className="login-card-top" style={{ background: '#fff', borderBottom: '1px solid #e2e8f0', padding: '2rem 2rem 1.5rem', textAlign: 'center' }}>
                        <img
                            src="/images/logo-light.jpg"
                            alt="Green Naturopathy"
                            style={{ width: '200px', maxWidth: '100%', height: 'auto', marginBottom: '1rem' }}
                        />
                        <h2 style={{ color: '#0f172a', marginBottom: '0.5rem' }}>Welcome to Green Naturopathy</h2>
                        <p className="text-muted small mb-3">Pain Clinic &amp; Holistic Healthcare</p>
                        
                        <div className="d-flex flex-column gap-2 mt-3" style={{ maxWidth: '280px', margin: '0 auto' }}>
                            <a
                                href={websiteUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-success rounded-pill px-4 btn-sm fw-semibold"
                            >
                                <i className="fa fa-globe me-2"></i>Visit Official Website
                            </a>
                            <a
                                href={reviewUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-danger rounded-pill px-4 btn-sm fw-semibold"
                            >
                                <i className="fab fa-google me-2"></i>Rate Us on Google
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
